import { styled } from "@mui/material/styles";

const BookingsMain = styled("div")(({ theme }) => ({
  "& .css-5ekgql": {
    marginTop: "10px",
  },
}));
const BookingsSelectDate = styled("div")(({ theme }) => ({
  position: "relative",
  marginTop: "15px",
  width: "20%",
}));

export { BookingsMain, BookingsSelectDate };
